import { MenuEntry } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

const config: (t: ContextApi['t']) => MenuEntry[] = (t) => [
 
      
      // {
      //   label: t('LP Migration'),
      //   href: 'https://v1exchange.glenty.com/#/migrate',
      // },
      // {
      //   label: t('V1 Liquidity (Old)'),
      //   href: 'https://v1exchange.glenty.com/#/pool',
      // },
    
]

export default config
